import { isActionRelevant } from './utils'

/** Some actions require the state to be added to the action payload. */
export const addStateToAction = store => next => action => {
  // Define which action types should have state added using regex pattern
  // Right now we only need to do this for the care detail/episode calls
  // because we parse the payload in `careMiddleware` and save it to redux.
  const relevantActions = [
    /FETCH_CARE_DETAIL_SUCCESS/,
    /FETCH_CARE_EPISODE_SUCCESS/,
    /FETCH_POLICY_SUCCESS/,
  ]

  // Only add state if the action is relevant
  if (isActionRelevant(action, relevantActions)) {
    action = {
      ...action,
      state: store.getState(),
    }
  }

  return next(action)
}
